import React from 'react';
import BackButton from '../BackButton';
import './projectFile'; // Custom styles for this project

const ProjectHeader = ({ title, date, featured = false }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div className="project-page-header">
      <BackButton />
      
      <header className="project-page-header">
        <h1 className="project-page-title">
          {title}
          
        </h1>
        
        <div className="project-page-date">
          <time>{formatDate(date)}</time>
        </div>
      </header>
    </div>
  );
};

export default ProjectHeader;